import React from 'react';
import { flow, head } from 'lodash';
import { connect } from 'react-redux';
import { DemographicsCard } from './DemographicsCard';
import { Stories } from 'ds/components/stories';
import { State } from 'store/state';
import { makeInsightsByTypeSelector } from 'store/state/domainData/selectors';
import { InsightDescriptor, IInsight } from 'utils/entities';
import { IDemographicsSummary } from 'store/state/selectors/insights/summaryTypes';
import { DemographicsWidgetWrapper } from './styled';

interface DemographicsWidgetProps {
  demographicsSummary: IDemographicsSummary;
}

const DemographicsWidgetView: React.FC<DemographicsWidgetProps> = React.memo(({ demographicsSummary }) => {
  if (!demographicsSummary || !demographicsSummary.length) return null;
  return (
    <DemographicsWidgetWrapper>
      <Stories withArrows>
        {demographicsSummary.map(({ category, text }, index) => (
          <DemographicsCard
            key={index}
            category={category}
            text={text}
          />
        ))}
      </Stories>
    </DemographicsWidgetWrapper>
  );
});

const demographicsInsightSelector = flow(makeInsightsByTypeSelector(InsightDescriptor.Demographics), head);
export const demographicsSummarySelector = flow(
  demographicsInsightSelector,
  (insight: IInsight) => insight && insight.summary && insight.summary.nonText ? insight.summary.nonText.data : []);

const mapStateToProps = (state: State) => ({
  demographicsSummary: demographicsSummarySelector(state),
});

export const DemographicsWidget = connect(mapStateToProps)(DemographicsWidgetView);
